import React, { useState } from "react";
import { notification } from "antd";
import { apiRequest } from "util/services";
import Representation from './Representation';
import i18n from 'i18next';

const Modal = ({ user, showModal, setShowModal, getSubscribtionStatus }) => {
  const [appId, setAppId] = useState("");
  const [appSecret, setAppSecret] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [adToken, setAdToken] = useState("");

  const onSubmit = async () => {
    const payload = {
      firebase_id: user.uid,
      facebook_app_id: appId,
      facebook_app_secret: appSecret,
      access_token: accessToken,
      ad_access_token: adToken,
    }
    const result = await apiRequest("users/add_facebook_keys", "POST", payload, true);
    if (result && !result.error) {
      notification.success({
        message: i18n.t("notifications.112"),
      });
      getSubscribtionStatus();
    } else {
      notification.error({ message: result.error });
    }
    setShowModal(false);
  }

  return <Representation
    setAccessToken={setAccessToken}
    setAdToken={setAdToken}
    setAppSecret={setAppSecret}
    setAppId={setAppId}
    onSubmit={onSubmit}
    showModal={showModal}
    setShowModal={setShowModal}
  />
}

export default Modal;